export const ACTIONS = {
    INTERNAL_SERVER_ERROR: '/error-500',
    PAGE_403:'/page403',
    PAGE_NOT_FOUND: '/pagenotfound',
    UNAUTHORIZED: '/unauthorized',
    SIGN_IN: '/signin',
    ADMIN_SIGN_IN: '/admin/signin',
    DASHBOARD: '/',
    REGISTER_PROFILE: '/registerCustomer',
    UPDATE_CUSTOMER: '/personalinformation',
    CHANGE_PASSWORD: '/changepassword',
    MANAGE_USERS: '/manageusers',
    REGISTERED_CUSTOMERS: '/manageregisteredcustomers',
    GUEST_CUSTOMERS: '/manageguestcustomers',
    MANAGE_ROLES: '/manageroles',
    MANAGE_MANUFACTURERS: '/managemanufacturers',
    MANAGE_ATTRIBUTE: '/managemasterattributes',
    SAVED_PART_NO: '/savedpartnumbers',
    ACCESS_PAGE: '/home',
    CALCULATOR_LIST:'/calculatorlist',
    SET_PASSWORD:'/setpassword',
    SET_ADMIN_PASSWORD:'/setadminpassword',
    MANAGE_PRICING:'/managepricings',
    PRICING_HISTORY:'/pricinghistory',
    CALCULATOR: '/calculatoroutput',
    COMING_SOON:'/comingsoon' 
};

export const APP_DETAILS={
    SALES_EMAIL : 'sales@nabell.com',
    CONTACT_NUMBER : '800-650-2015',
    APPLICATION_NAME_FOOTER : 'Nabell USA Corporation',
};

export const SERVER_ACTIONS = {
    /*COMMON API */
    //API:  'http://localhost:3001',
    //API : 'http://localhost:62295/',
    //API:  'http://192.168.4.17:8083',
    API:  'https://api.bellowscalculator.com/', 
    SIGN_IN: '/api/v1/userlogin',
    ADMIN_SIGN_IN: '/api/v1/userlogin',
    TOKEN: "/token",
    POST_REGISTER_PROFILE: "/api/v1/register_customer",

    //dropdown
	GET_ALL_USERTYPE: "/api/v1/get_usertypes",
    GET_ALL_COUNTRIES: "/api/v1/get_countries",
    GET_ALL_COMPANY_TYPES: "/api/v1/get_companytypes",
    GET_ALL_MANUFACTURERS: "/api/v1/get_all_manufacturers",
    GET_ALL_STATES: '/api/v1/get_states_by_country',
    GET_ALL_ROLES: '/api/v1/get_allroles',
    GET_ALL_RAILS: '/api/v1/get_rails_by_manufacturerid',
    GET_ALL_KRSERIES: '/api/v1/get_krseries_by_manufacturerid',
    GET_ALL_SIZES: '/api/v1/get_size_by_railbellow',
    GET_ALL_BELLOWS: '/api/v1/get_bellows_by_railid',  
    GET_ALL_MATERIALS: '/api/v1/get_materials_by_manufacturerid',
    GET_ALL_IKNOWPARTNUMBER_MATERIAL: '/api/v1/get_iknowpartnumber_material',
    GET_ALL_MATERIALS_FOR_CALCULATOR: '/api/v1/get_materials_by_sizeid',
    GET_ALL_KR_MATERIALS: '/api/v1/get_krseriesmaterial_by_seriesid',
    GET_ALL_BLOCK_TYPE: '/api/v1/get_blocktype_by_railid',
    GET_ALL_ACCESSORIES:'/api/v1/get_accessories_by_sizeid',
    GET_ALL_RAIL_LENGTH: '/api/v1/get_krraillength_by_krseriesid',
    GET_ALL_MANUFACTURERS_CALCULATORS: "/api/v1/get_user_calculators",
    GET_ALL_RAILBELLOW_BY_MANUFACTURER:'/api/v1/get_railbellows_bymanufacturer',
    GET_ALL_BLOCK_BY_SIZE_MANUFACTURER:'/api/v1/get_block_by_size_manufacturer',
    GET_ALL_ACCESSORIES_BY_MANUFACTURER_SIZE:'api/v1/get_all_accessory_by_manufacturer_sizeid',


    POST_GUEST_LOGIN: '/api/v1/guest-login',
    POST_GUEST_REGISTER: '/api/v1/guest-register',
    GET_CUSTOMER_PROFILE_BY_ID: '/api/v1/get_customer_by_id',
    POST_UPDATE_CUSTOMER_PROFILE: '/api/v1/update_customer_profile',
    POST_UPDATE_ADMIN_PROFILE: '/api/v1/update_admin_profile',
    POST_CHANGE_PASSWORD: '/api/v1/update_password',
    POST_UPDATE_USER: '/api/v1/update_admin_user',
    POST_USERS: '/api/v1/get_admin_users',
    POST_STATUS_USER: '/api/v1/update_user_status',
    DELETE_USER: '/api/v1/delete_user',
    GET_ALL_SIZES_BY_MANUFACTURER:'/api/v1/get_all_size',
    GET_SIZES_BY_MANUFACTURER:'/api/v1/get_manufacturer_size',
    GET_SIZES_BY_BELLOWS:'/api/v1/get_size_by_bellows',


    POST_ADD_CALCULATOR:'/api/v1/create_calculator',
    POST_CALCULATORS: '/api/v1/get_calculators',
    GET_CALCULATOR_BY_MANUFACTURER_ID:'/api/v1/get_calculator_by_manufacturerid',
    POST_CALCULATOR_STATUS:'/api/v1/update_calculator_status',
    PUT_EDIT_CALCULATOR:'/api/v1/update_calculator',
    DELETE_CALCULATOR:'/api/v1/delete_calculator',
    GET_FORMULA_BY_CALCULATOR_ID:'/api/v1/get_formulae_by_calculator_id',
    POST_CREATE_CALCULATOR_FORMULA:'/api/v1/create_calculator_formula',
    DELETE_CALCULATOR_FORMULA_BY_ID:'/api/v1/delete_calculator_formula_by_formula_id',


    GET_ATTRIBUTES:'/api/v1/get_allmasterattribute',

    POST_RAILS_ATTRIBUTES:'/api/v1/save_update_rail',
    GET_RAILS_ATTRIBUTES:'/api/v1/get_all_rails',
    DELETE_RAIL_ATTRIBUTE:'/api/v1/delete_rail',

    POST_BELLOW_ATTRIBUTES:'/api/v1/save_update_bellows',
    GET_BELLOW_ATTRIBUTES:'/api/v1/get_all_bellows',
    DELETE_BELLOW_ATTRIBUTE:'/api/v1/delete_bellow',

    POST_SIZE_ATTRIBUTES:'/api/v1/save_update_size',
    GET_SIZE_ATTRIBUTES:'/api/v1/get_size_by_railbellowid',
    DELETE_SIZE_ATTRIBUTE:'/api/v1/delete_size',

    POST_BLOCK_ATTRIBUTES:'/api/v1/save_update_block',
    GET_BLOCK_ATTRIBUTES:'/api/v1/get_all_blocks',
    DELETE_BLOCK_ATTRIBUTE:'/api/v1/delete_block',

    POST_ACCESSORY_ATTRIBUTES:'/api/v1/save_update_accessory',
    GET_ACCESSORY_ATTRIBUTES:'/api/v1/get_all_accessory',
    DELETE_ACCESSORY_ATTRIBUTE:'/api/v1/delete_accessory',

    POST_MATERIAL_ATTRIBUTES:'/api/v1/save_update_material',
    GET_MATERIAL_ATTRIBUTES:'/api/v1/get_all_materials',
    DELETE_MATERIAL_ATTRIBUTE:'/api/v1/delete',

    POST_RAILBELLOW_ATTRIBUTES:'/api/v1/save_update_railbellow',
    GET_RAILBELLOW_ATTRIBUTES:'/api/v1/get_all_railbellows',
    DELETE_RAILBELLOW_ATTRIBUTE:'/api/v1/delete_railbellow',

    POST_KRSERIES_ATTRIBUTES:'/api/v1/save_update_krseries',
    GET_KRSERIES_ATTRIBUTES:'/api/v1/get_krseries',
    DELETE_KRSERIES_ATTRIBUTE:'/api/v1/delete_krseries',

    POST_KRMATERIAL_ATTRIBUTES:'/api/v1/save_update_krmaterial',
    GET_KRMATERIAL_ATTRIBUTES:'/api/v1/get_krmaterial',
    DELETE_KRMATERIAL_ATTRIBUTE:'/api/v1/delete_krmaterial',

    POST_KRRAILLENGTH_ATTRIBUTES:'/api/v1/save_update_krraillength',
    GET_KRRAILLENGTH_ATTRIBUTES:'/api/v1/get_all_krraillength',
    DELETE_KRRAILLENGTH_ATTRIBUTE:'/api/v1/delete_krraillength',

    POST_RAILBLOCK_ATTRIBUTES:'/api/v1/save_update_railblock',
    GET_RAILBLOCK_ATTRIBUTES:'/api/v1/get_all_railblock',
    DELETE_RAILBLOCK_ATTRIBUTE:'/api/v1/delete_railblock',

    POST_SIZEBLOCK_ATTRIBUTES:'/api/v1/save_update_sizeblock',
    GET_SIZEBLOCK_ATTRIBUTES:'/api/v1/get_all_sizeblock',
    DELETE_SIZEBLOCK_ATTRIBUTE:'/api/v1/delete_sizeblock',

    POST_KRSERIES_MATERIAL_ATTRIBUTES:'/api/v1/save_update_krseriesmaterial',
    GET_KRSERIES_MATERIAL_ATTRIBUTES:'/api/v1/get_krseriesmaterial',
    DELETE_KRSERIES_MATERIAL_ATTRIBUTE:'/api/v1/delete_krseriesmaterial',

    POST_SIZE_ACCESSORY_ATTRIBUTES:'/api/v1/save_update_sizeaccessory',
    GET_SIZE_ACCESSORY_ATTRIBUTES:'/api/v1/get_all_sizeaccessory',
    DELETE_SIZE_ACCESSORY_ATTRIBUTE:'/api/v1/delete_sizeaccessory',

    POST_LENGTH_ATTRIBUTES:'/api/v1/save_update_length',
    GET_LENGTH_ATTRIBUTES:'/api/v1/get_all_length',
    DELETE_LENGTH_ATTRIBUTE:'/api/v1/delete_length',

    POST_BELLOWSMAPPING_ATTRIBUTES:'/api/v1/save_update_bellows_mapping',
    GET_BELLOWSMAPPING_ATTRIBUTES:'/api/v1/get_bellows_mapping',
    DELETE_BELLOWSMAPPING_ATTRIBUTE:'/api/v1/delete_bellows_mapping',

    GET_OLD_BELLOW_ATTRIBUTES:'/api/v1/get_old_bellows',
    GET_NEW_BELLOW_ATTRIBUTES:'/api/v1/get_new_bellows',

    POST_REGISTERED_CUSTOMERS: '/api/v1/get_register_customers',
    POST_STATUS_CUSTOMER: '/api/v1/update_customer_status',
    POST_UPDATE_CUSTOMER: '/api/v1/add_update_customer_by_admin',
    DELETE_CUSTOMER: '/api/v1/delete_customer',
    GET_ALL_CALCULATOR_LIST: '/api/v1/get_customercalculators',

    POST_GUEST_CUSTOMERS: '/api/v1/get_guest_customers',

    POST_ROLES: '/api/v1/get_roles',
    POST_CREATE_ROLE: '/api/v1/save_role',
    POST_STATUS_ROLE: '/api/v1/update_role_status',
    DELETE_ROLE: '/api/v1/delete_role',
    GET_ROLE_ACCESSPERMISSIONS: '/api/v1/get_accesspermission_byrole',
    GET_ROLE_ATTRIBUTE :'/api/v1/get_roleattribute',
    POST_ROLE_ATTRIBUTE :'/api/v1/save_roleattribute',

    GET_MANUFACTURERS: '/api/v1/get_manufacturers',
    GET_MANUFACTURER_CALC: '/api/v1/get_manufacturercalculators',
    //GET_ACTIVE_MANUFACTURER_CALC: '/api/v1/get_manufacturercalculators',
    
    PUT_MANUFACTURERS: '/api/v1/update_manufacturer',
    POST_MANUFACTURERS: '/api/v1/create_manufacturer',
    POST_STATUS_MANUFACTURER: '/api/v1/update_manufacturer_status',
    DELETE_MANUFACTURER: '/api/v1/delete_manufacturer',

    GET_USER_MENU: '/api/v1/get_usermenu_by_userid',
    POST_FORGOT_PASSWORD: '/api/v1/forgotpassword',
     
    POST_SET_PASSWORD:'/api/v1/setpassword',
    GET_ADMIN_PROFILE_BY_ID: '/api/v1/get_user_by_id',


    POST_ADMIN_FORGOT_PASSWORD: '/api/v1/forgotadminpassword',
    POST_SET_ADMIN_PASSWORD:'/api/v1/setadminpassword',

    //manage pricing
    POST_PRICING_HISTORY: '/api/v1/get_pricing_history',
    POST_PRICING_HISTORY_UPDATE:'/api/v1/update_pricing_history',
    POST_PRICING_HISTORY_DELETE: '/api/v1/delete_pricing_history',
    GET_SIZE_DETAIL: '/api/v1/get_size_detail',
    POST_UPDATE_SIZE_DETAIL: '/api/v1/update_size_detail',
    GET_RAIL_BELLOW_PROPERTY: '/api/v1/get_rail_bellow_property',
    POST_RAIL_BELLOW_PROPERTY: '/api/v1/save_update_railbellowsproperties',
    GET_MARKUPS_BY_MANUFACTURER: '/api/v1/get_markups_by_manufacturerid',
    POST_MARKUPS: '/api/v1/save_manufacturer_markup',

    //Calculator OutPut
    GET_IKNOW_STROKE_LENGTH_OUTPUT:'/api/v1/get_iknowlength_output',
    GET_KR_SERIES_OUTPUT: '/api/v1/get_krseriesoutput',
    GET_PARTNUMBER_OUTPUT: '/api/v1/get_partnumberoutput',

    POST_DEFAULT_VALUES_FOR_KRSERIES: '/api/v1/krseriescalculator_defaultvalues',
    POST_DEFAULT_VALUES_FOR_STROKE_LENGTH: '/api/v1/IKnowlengthcalculator_defaultvalues',

    POST_DEFAULT_VALUES_FOR_IKNOWPARTNUMBER: '/api/v1/IKnowPartNumbercalculator_defaultvalues',

    //SavePartNumber
    POST_SAVEPARTNUMBER:'/api/v1/savepartnumber',
    POST_SAVED_PART_NUMBER: '/api/v1/get_partnumberlist',
    GET_SAVED_PART_NUMBER: '/api/v1/getsavedpartnumberdata',

    // Access page 
    GET_USER_CALCULATORS: '/api/v1/get_user_calculators',

    GET_IS_URL_ACCESSIBLE: '/api/v1/get_isurlaccessible_byuserid',
};

export const ToolbarOptions = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction

        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],

        ['clean'] // remove formatting button
    ]
};

export const FORM_TYPE = {

    NORMAL_FORM: 0,
    PRODUCT_FORM: 1,
    ORDER_RENEW_FORM: 2,
    ORDER_REVOKE_FORM: 3,
    ORDER_DOWNLOAD_FORM: 4,
    CONTACT_US_FORM: 5,
    SURVEY_FORM: 6,
    SUPPORT_CONTACT_CALL: 7,
    SUPPORT_CONTACT_EMAIL: 8

}
export const REGEX = {
    ALPHABETS: /^[a-zA-Z]*$/,
    ALPHABETS_WITH_SPACE: /^[a-zA-Z  ]*$/,
    PHONE: /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
    WHOLE_NUMBER: /^\d+$/,
    DECIMAL_NUMBER: /^\d*\.\d+$/,
    WHOLE_OR_DECIMAL: /^\d*(\.\d+)?$/,
    ALPHANUMERIC_WITHOUT_SPACE: /^[-a-zA-Z0-9_.]*$/,
    ALPHANUMERIC_WITH_SPACE: /^[-a-zA-Z0-9,()#.!&%$@'";:?/*=+ ]*$/,
    TEXT: /^[-a-zA-Z0-9,+:.()/\ ]*$/,
    TEXT_WITH_SPECIAL_CHAR: /^[-a-zA-Z0-9,()#.!&%$@'";:?/*=+ ]*$/,
    EMAIL: /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,
    PASSWORD: /(?=(.*[0-9]))(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,}/,
    URL: /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
    SLUG: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    MULTILANGUAGE_ALPHANUMERIC_WITHOUT_SPACE: /([\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9]+)/g,
    // MULTILANGUAGE_ALPHANUMERIC_WITH_SPACE: /^([\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC ()-?:;'"+=%&@,.#!]*)/g,
    MULTILANGUAGE_ALPHANUMERIC_WITH_SPACE: /^[-a-zA-Z0-9,()#.!&%$@;:?/*=+ ]*$/,
    PAGE_TITLE: /^[-a-zA-Z0-9,()#.!&%$@'";:?/*=+ ]*$/,
    PAGE_URL: /^[-a-zA-Z0-9,()#.!&%$@'";:?/*=+ ]*$/,
    CARD_NUMBER: /\b(?:\d[ -]*?){13,16}\b/ ,


}

export const REGEX_ERROR = {
    ALPHABETS_ERROR: 'Please Enter Single Word With Alphabets Only And No Space',
    ALPHABETS_WITH_SPACE_ERROR: 'Please Enter Alphabets Only',
    PHONE_ERROR: 'Please Enter Valid Phone Number',
    WHOLE_NUMBER_ERROR: 'Please Enter Full Number Only',
    DECIMAL_NUMBER: 'Please Enter Decimal Number Only',
    WHOLE_OR_DECIMAL_ERROR: 'Please Enter Number Only',
    ALPHANUMERIC_WITHOUT_SPACE_ERROR: 'Please Enter Alphanumeric Without Space',
    ALPHANUMERIC_WITH_SPACE_ERROR: 'Please Enter Alphanumeric Only',
    TEXT_ERROR: 'Please Enter Valid Text Without Special Characters',
    TEXT_WITH_SPECIAL_CHAR_ERROR: 'Please Enter Valid Text',
    EMAIL_ERROR: 'Please Enter Valid Email Address',
    PASSWORD_ERROR: 'Please Enter Atleast 1 Capital, 1 Lower Case, 1 Number And 1 Special Character',
    URL_ERROR: 'Please Enter Valid URL',
    SLUG_ERROR: 'Please Enter Valid data',
    MULTILANGUAGE_ALPHANUMERIC_WITHOUT_SPACE_ERROR: 'Please Enter Single Word Only',
    MULTILANGUAGE_ALPHANUMERIC_WITH_SPACE_ERROR: 'Special Charactors Not Allowed',
    PAGE_TITLE_ERROR: 'Please Enter Alphanumeric Only',
    PAGE_URL_ERROR: 'Please Enter Valid Data',
    CARD_NUMBER_ERROR: 'Please Enter valid card Number',
}